// extracted by mini-css-extract-plugin
module.exports = {"warning":"CreateImage_warning__3K6LG","bold":"CreateImage_bold__18wPB"};